export const pagetitle = {
    DFS: '24時間対応のコンシェルジュ',
    Hotel: 'ホテルのお得情報',
    Enquiry: '一般的なお問い合わせ',
    Detail: 'サービス詳細',
    Search: '検索'
}

export const home = {
    recommend: 'おすすめのサービス',
    benefits: 'ご優待と特典',
    benefitsInfo: 'DFSのコンシェルジュサービスや、旅とライフスタイルの体験、カスタマイズされた特典、ロイヤルティーの各種ソリューションとの出会いが待っています。',
    contact: '問い合わせしますか？',
    hotline: 'お電話',
    livechat: 'チャット',
    more: 'もっと見る',
    welcometitle: '24時間対応のDFS CIRCLE ライフスタイルラグジュアリーコンシェルジュへようこそ',
    welcomedetail: 'こちらでは、DFS CIRCLE 最上ステージの会員様に、ホテルのご予約やレストランのご紹介などの格別なパーソナライズサービスを数多くご用意しました。',
    welcomenotice: '本セクションとご紹介している各種サービスは、提携企業であるAspire社がご提供しております。収集したデータはすべて、サービスの実施、サービス品質のモニタリング、社内の研修実施のみの目的で使用されます。',
    selectnumber: '市内番号でお問い合わせください',
    selectnumbertips:'当社のカスタマー サービス チームは、選択した場所に応じて、英語、北京語、広東語、または日本語で対応します。',
    selectnumbernotice:'*サービスプロバイダーによっては、国内/海外料金が適用される場合があります。'
}

export const service = {
    title: 'DFS CIRCLEでご予約して、限定特典を受け取る',
    list1: '特別オファーをアンバサダーステージの会員様のためだけにご用意',
    list2: 'お部屋の無料アップグレードと朝食サービス',
    list3: 'アーリーチェックインとレイトチェックアウト、リゾート、スパクレジット',
    tips: '提供される特典は空室状況によりご利用いただけない場合があります',
    more: '続きを見る',
    less: 'あまり見ない'
}

export const toolbar = {
    hotel: 'ホテル',
    dinning: '飲食',
    travel: '旅行',
    entertainment: '娯楽',
    club: 'プライベートクラブ',
    education: '教育',
    golf: 'ゴルフ',
    business: 'ビジネス',
    reservation: 'ホテルのご予約'
}

export const category = {
    hotel: 'ホテル',
    dinning: '飲食',
    travel: '空港と旅行のサービス',
    entertainment: '娯楽',
    club: 'プライベートクラブ',
    education: '教育',
    golf: 'ゴルフ',
    business: 'ビジネス',
}

export const info = {
    hotel: 'DFSのコンシェルジュサービスで次の旅行を予約しましょう。ラグジュアリーな滞在時にうれしい、無料アップグレードや朝食サービスのほか、ここだけのVIPな特典が目白押しです。',
    dinning: '最高のレストランを訪れたり、世界各地のユニークな料理やワインを堪能しませんか？DFSのコンシェルジュチームが、必要なタイミングで最高のお店とお席を確保します。',
    travel: '旅行',
    entertainment: '娯楽',
    club: 'プライベートクラブ',
    education: '教育',
    golf: 'ゴルフ',
    business: 'ビジネス',
}

export const city = {
    hotcity: '人気の旅先',
    shanghai: '上海',
    osaka: '大阪',
    singapore: 'シンガポール',
    hiangmai: 'チェンマイ',
    paris: 'パリ',
    london: 'ロンドン',
    newyork: 'ニューヨーク',
    sydney: 'シドニー'
}

export const hotel = {
    title: '次の旅行をご予約',
    more: '詳しい情報を見る',
    location: '旅先',
    searchcity: '都市を検索',
    pickdate: '期間を選択',
    travelernumber: '旅行者の人数',
    childnumber: 'お子様の人数',
    nightSin: '泊',
    nightPlu: '泊',
    room: '部屋',
    roomSin: '室',
    roomPlu: '室',
    adults: '大人の人数',
    adultSin: '名',
    adultPlu: '名',
    children: '子供の人数',
    childSin: '名',
    childPlu: '名',
    travelerSin: '名の旅行者',
    travelerPlu: '名の旅行者',
    age: '0～16歳',
    group: 'ご予約は1泊からです',
    all: 'すべて',
    hotcity: '人気の旅先',
    brandfilter: 'ホテルグループ',
    pricefilter: '価格',
    privilege: 'VIP Privileges',
    discount: '最大割引',
    from: '最小価格',
    full: '適用できない',
    empty: '情報がありません',
    noroomdata: 'あなたが選んだ日付には部屋がありません。',
    selectroom:'部屋を選択',
    roomtype: '部屋タイプ',
    facility: '設備とサービス',
    policy: 'キャンセルポリシー',
    noncancel: '返金不可',
    deadline: 'キャンセル期限',
    searchtip: '提携ホテル以外のホテルが必要な場合は、カスタマーサービスまでご連絡ください。'
}

export const buttonTxt = {
    done: '完了',
    cancel: 'キャンセル',
    search: '検索',
    selectroom: '部屋を選択',
    bookroom: '予約する',
    confirmbook: '確認',
    myorder: '予約内容を見る',
    gohome: 'ホームに戻る',
    reserve: '予約',
    enquire: 'お問い合わせ',
    submitEnquire: 'お問い合わせ',
    accept: '承認',
    change: '予約を変更する',
    cancelOrder: '注文を取り消す',
    confirm: '確認',
    notcancel: 'キャンセルしないでください'
}

export const toast = {
    pickerdate: '少なくとも一晩は',
    errorEmail: 'メールが正しくありません',
    errorName: '英字で入力してください',
    unLogin: 'ログインしていません',
    nologin: 'ユーザー情報が不足しています。再度ログインしてください',
    cancelTitle: '注文をキャンセルしますか?',
    cancelTip: 'キャンセルすると注文は復元されません。キャンセルしてもよろしいですか?',
    cancelsuccess:'成功をキャンセルする',
    cancelfailed:'キャンセルに失敗しました',
    requesterror: '購読に失敗しました。後で再試行してください'
}

export const form = {
    searchcity: '都市を検索',
    searchkey: 'キーワードを検索',
    roomnumber: '部屋数',
    peopleNumber: '旅行者の人数',
    checkin: 'チェックイン日',
    checkout: 'チェックアウト日',
    cost: '合計価格',
    price: '部屋のレート',
    other: 'その他',
    tax: '税・サービスチャージ',
    information: 'ご連絡先情報',
    name: '氏名',
    gender: '敬称',
    male: 'Mr.',
    female: 'Ms.',
    firstname: '名',
    lastname: '姓',
    contactmobile: '電話番号',
    areacode: '市外局番',
    mobile: '電話番号',
    contactemail: 'メール',
    emailaddress: 'メールアドレス',
    contacttime: 'ご連絡のタイミング',
    dateperiod: 'ご希望の日',
    timeperiod: 'ご希望の時間帯',
    timedetail: 'DFSのラグジュアリーコンシェルジュが連絡してもよい日にちと時間を選択してください。',
    fqt: 'フリークエントトラベラープログラムコード',
    fqttip: 'チェックイン時にホテルにご確認ください。',
    codenumber: 'フリークエントトラベルプランコード',
    special: '特別なご要望',
    specialtip: 'ご要望はこちらにご入力ください。200文字まで。',
    payment: 'お支払い詳細',
    paymentmethod: 'お支払い方法',
    cardtype: 'カードの種類',
    cardnumber: 'カード番号',
    expiration: '有効期限',
    month: '月（MM）',
    year: '年（YY）',
    creditcard: 'クレジットカード',
    success: 'ご予約を完了しました！',
    enquiresent: 'クエリが送信されました',
    successnotice: 'お客様のご予約を受け付けました。追ってご連絡いたします。',
    contactdetail: 'お客様が予約されたサービスについて、メール、SMS、お電話のいずれかでご連絡いたします。',
    contactmethod: 'ご希望の連絡手段',
    phonecall: 'お電話',
    email: 'メール',
    anyday: 'いつでも',
    weekday: '平日',
    weekend: '週末',
    anytime: 'いつでも',
    morning: '午前',
    afternoon: '午後',
    evening: '夜間',
    additional: 'その他のご要望',
    additionaltip: 'その他にご要望がございましたら、以下に記入してください。',
    attendeenumber: '同伴者数',
    attendee: '同伴者',
    reservedate: 'ご予約日',
    time: '24時間以上前までにご予約ください',
    call: '電話',
    isrequired:'必須'
}

export const order = {
    checkin: 'チェックイン',
    checkout: 'チェックアウト',
    total: '合計',
    reservation: '注文日',
    success: 'ご予約完了',
    cancel: 'キャンセル完了',
    name: '名前',
    phone: '電話番号',
    email: 'メールボックス',
    useDate: 'ご予約日',
    special: '特別なご要望'
}

export const other = {
    hotcity: '人気の旅先',
    address: '住所',
    summary: '概要',
    details: '詳細',
    clause: 'ご注意',
    service: 'お問い合わせ',
    reservation: 'お問い合わせ',
    terms: 'Terms & Conditions',
    termsdetail: '<p>1. Certain room types are not eligible for room upgrades or special offers.</p><p>2. If there is any change in the room type, the hotel reserves the right of final interpretation.</p><p>3. Not all participating hotels offer in-room Wi-Fi benefits. Please call the customer service hotline for more details.</p><p>4. Hotel experience privileges vary by hotel, please call the customer service hotline for more details.</p>',
    domestic:'中国'
}

export const telephone = {
    China: '中国',
    Macao: 'マカオ',
    Japan: '日本',
    HongKong: '香港',
    Guam: 'グアム',
    Australia: 'オーストラリア',
    France: 'フランス語'
}


// WEBPACK FOOTER //
// ./src/language/jp.js